<template>
    <transition name="fade">
        <div class="vue-modal" v-show="open">
            <transition name="drop-in">
                <div class="vue-modal-inner" v-show="open">
                    <div class="vue-modal-content shadow-lg" style="min-width: 600px; background-color: var(--form-color); color: var(--theme-text-main); border-radius: 15px; padding: 30px;">
                        <div v-if="!paymentPending">
                            <p class="h3 my-3 text-seccess fw-bold">Please Select Payment Mobile Provider</p>
                            <div class="wrap-input100 validate-input">
                                <select class="form-control input-lg" id="mobilePaymentProvider" v-model="mobilePaymentProvider"
                                    name="mobilePaymentProvider" 
                                    :class="{ 'is-invalid': submitted && !mobilePaymentProvider }"
                                    style="font-size:1.3em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);">
                                    <option value="" selected hidden>Select Mobile Payment Provider</option>
                                    <option v-for="mobilePaymentProvider of allMobilePaymentProviders"
                                        :key="mobilePaymentProvider.id" :value="mobilePaymentProvider.name" style="color: black;">{{
                                            mobilePaymentProvider.name }}
                                    </option>
                                </select>
                                 <div v-if="submitted && !mobilePaymentProvider" class="text-danger mt-1">
                                     Please select a mobile payment provider
                                 </div>
                            </div>

                            <span v-if="mobilePaymentProvider == 'Mobile MTN'">
                                <p class="h3 text-seccess fw-bold">Please Enter Customer Mobile Number (EX:256791231231)</p>
                                <input @focus="focusedInp = 'number'" type="text" class="form-control input-lg" name="mobileNumber" v-on:keyup.enter="passMobileAmount()"
                                id="mobileAmount" :value="mobileNumber" @change="mobileNumber = $event.target.value" style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main); text-align: center;" />
                            </span>
                            
                            <p class="h3 text-seccess fw-bold">Please Enter Mobile Paid Amount</p>
                            <slot />
                            <input @focus="focusedInp = 'amount'" type="text" class="form-control input-lg" name="mobileAmount" v-on:keyup.enter="passMobileAmount()"
                                id="mobileAmount" :value="selfMobileAmount" @input="selfMobileAmount = Math.min(selfMobileAmount, mobileAmount)"  :placeholder="mobileAmount" @change="selfMobileAmount = $event.target.value" style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main); text-align: center;" />

                    
                            <br>
                            <div style="width: 100%;display:flex;justify-content:space-between;align-items: center;">
                                <button style="min-width:12rem" @click="closePopUp" class="btn btn-danger btn-lg">Close</button>
                                <button v-if="mobilePaymentProvider == 'Mobile MTN'" class="btn btn-success btn-lg" @click="createMTNPayment()">Create MTN Payment Request</button>
                                <button v-else style="min-width:12rem" class="btn btn-success btn-lg" @click="passMobileAmount()">Add Payment</button>
                            </div>
                        </div>
                        <div v-else>
                            <p class="h3 my-3 text-seccess fw-bold">Pending Payment Result....</p>
                            <div style="width: 100%;display:flex;justify-content:space-between;align-items: center;">
                                <button class="btn btn-primary btn-lg" @click="checkMTNStatus()">Get Payment Response</button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <div class="col-sm-4" v-if="!paymentPending"
                style="position:fixed;width:250px;height:300px; min-height: 200px;left:0px;bottom:-80px;margin-top: 0px;margin-left: -15px;margin-right: -10px;">
                <numericpad :onInput="onInput" :onDelete="onDelete" :onReset="onReset" :show="true" />
            </div>
        </div>
    </transition>
</template>
<script>
import Vue from 'vue';
import commonServices from "@/shared/commonServices"
import mtn from "@/shared/mtn"
import numericpad from "@/components/SimpleKeyboard";
import axios from 'axios';

export default {
    mixins: [commonServices, mtn],
    name: "PayMobile",
    data: function () {
        return {
            focusedInp: 'amount',
            refId: "",
            paymentPending: false,
            approved: false,
            selfMobileAmount: '',
            mobilePaymentProvider: "",
            mobileNumber: "",
            allMobilePaymentProviders: [],
            submitted: false,
        }
    },
    watch: {
        open(val) {
            if (val) {
                this.selfMobileAmount = '';
            }
        }
    },
    components: {
        numericpad
    },
    methods: {
        async checkMTNStatus(){
            if(await this.checkStatus(this.refId)){
                await this.showSuccess('Payment Collected Successfully!')
                this.approved = true;
                this.passMobileAmount();
            }else{
                await this.showAlert('Payment Not Collected Yet...')
            }
        
        },
        onInput(key) {
            if (key == 11) {
                if(this.focusedInp == 'amount'){
                    this.selfMobileAmount = (this.selfMobileAmount + '0')
                }else{
                    this.mobileNumber = (this.mobileNumber + '0')
                }
            } else {
                if(this.focusedInp == 'amount'){
                    this.selfMobileAmount = (this.selfMobileAmount + key)
                }else{
                    this.mobileNumber = (this.mobileNumber + key)
                }
            }
            //this.getProduct(this.barcode);

        },
        async createMTNPayment(){
            this.showInfo("Proccessing With MTN");
            this.refId = await this.createPayment(this.selfMobileAmount, this.mobileNumber);
            this.approved = false;
        },
        onDelete() {
            if(this.focusedInp == 'amount'){
                this.selfMobileAmount = this.selfMobileAmount.slice(0, this.selfMobileAmount.length - 1);
            }else{
                this.mobileNumber = this.mobileNumber.slice(0, this.mobileNumber.length - 1);
            }
        },
        onReset() {
            if(this.focusedInp == 'amount'){
                this.selfMobileAmount = "";
            }else{
                this.mobileNumber = "";
            }
        },
        closePopUp(){
            this.selfMobileAmount = '';
            this.close();
        },
        passMobileAmount() {
            this.submitted = true;

            if (!this.mobilePaymentProvider) {
                // this.showAlert("Please select Mobile Payment Provider");
                return;
            }

            
            let amount = this.selfMobileAmount;

            // إذا لم يدخل المستخدم قيمة استخدم placeholder
            if (!amount) {
                amount = this.mobileAmount;
            }

            // if (!this.selfMobileAmount) {
            //     this.showAlert("Please enter amount");
            //     return;
            // }

            if(this.mobilePaymentProvider == 'Mobile MTN' && !this.approved){
                this.createMTNPayment();
                return;
            }
            this.$emit('getMobileAmount', {
                "amount": amount,
                "provider": this.mobilePaymentProvider
            });
            this.selfMobileAmount= '';
            this.close();
        }
    },
    props: {
        open: {
            type: Boolean,
            required: true
        },
        mobileAmount: {
            type: String,
            required: true
        },
        custMobile: {
            type: String,
            required: false
        }

    },
    async mounted() {
        let mobilePaymentProviderJson = {};
        mobilePaymentProviderJson.appId = localStorage.appId;
        try {
            let dataURL = this.apiURL + 'MobilePaymentProviders/getAllMobilePaymentProviders';
            this.allMobilePaymentProviders = await axios.post(dataURL, mobilePaymentProviderJson).then(response => response.data.results);
            this.mobileNumber = this.custMobile
        }
        catch (error) {
            console.log(error);
        }
        if (this.open) {
            this.selfMobileAmount = '';
        }
    },
    setup(_, { emit }) {
        const close = () => {
            emit('close');
        };


        return { close };
    },
};
</script>
<style scoped>
*,
::before::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* .vue-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
}

.vue-modal-inner {
    max-width: 30%;
    max-height: 50%;
    margin: 2rem auto;
} */

.vue-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
}

.vue-modal-inner {
    max-width: 90%;
    max-height: 90vh;
    margin: 0;
}

.vue-modal-content {
    position: relative;
    background-color: #fff;
    border: 5px solid rgba(0, 0, 0, 0.3);
    background-clip: padding-box;
    border-radius: 1rem;
    padding: 1rem;
    width: 100%;
    height: 100%;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.drop-in-enter-active,
.drop-in-leave-active {
    transition: all 0.3s ease-out;
}

.drop-in-enter-from,
.drop-in-leave-to {
    opacity: 0;
    transform: translateY(50px);
}
</style>
